<template>
  <!-- 商品列表 -->
  <div>
    <!-- 页面布局 -->
    <!-- <wPageCrumbs> -->
    <!-- 筛选查询 -->
    <div class="wML-screen">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>筛选查询</span>
        </div>
        <!-- 筛选列表 -->
        <div class="wMLS-list">
          <el-form label-position="left" label-width="90px" :model="wScreen">
            <el-row :gutter="24">
              <!-- 商品唯一键 -->
              <el-col :span="6">
                <el-form-item label="商品唯一键">
                  <el-input style="width: 100%;" type="text" v-model="wScreen.goodsUniqueKey" placeholder="请输入商品唯一键" clearable></el-input>
                </el-form-item>
              </el-col>
              <!-- 关键字 -->
              <el-col :span="6">
                <el-form-item label="关键字">
                  <el-input style="width: 100%;" type="text" v-model="wScreen.search" placeholder="请输入关键字" clearable
                    @input="changeInputSearch"></el-input>
                </el-form-item>
              </el-col>
              <!-- 店铺名称 -->
              <el-col :span="6">
                <el-form-item label="店铺名称" prop="storeId">
                  <el-select v-model="wScreen.storeId" placeholder="请选择店铺" :clearable="clearableStoreId"
                    :disabled="disabledStoreId" @change="changeSelectStoreId" style="width: 100%;">
                    <el-option v-for="(item, index) in optionsStore" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 商品分类 -->
              <el-col :span="6">
                <el-form-item label="商品分类">
                  <el-select v-model="wScreen.categoryId" :placeholder="placeholderCategory" clearable
                    :disabled="disabledCategory" @change="changeSelectCategory" style="width: 100%;">
                    <el-option v-for="item in optionsCategory" :key="item.value" :label="item.label"
                      :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 商品状态 -->
              <el-col :span="6">
                <el-form-item label="商品状态">
                  <el-select v-model="wScreen.state" placeholder="请选择状态" clearable @change="changeSelectState"
                    style="width: 100%;">
                    <el-option v-for="item in optionsState" :key="item.value" :label="item.label" :value="item.value" />
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- 是否霸王餐 -->
              <!-- <el-col :span="6">
                <el-form-item label="是否霸王餐">
                  <el-select v-model="wScreen.ifBawangcan" placeholder="请选择" clearable @change="submitwScreen"
                    style="width: 100%;">
                    <el-option label="是" value="1" />
                    <el-option label="否" value="0" />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否充值大福利">
                  <el-select v-model="wScreen.ifFuli" placeholder="请选择" clearable @change="submitwScreen"
                    style="width: 100%;">
                    <el-option label="是" value="1" />
                    <el-option label="否" value="0" />
                  </el-select>
                </el-form-item>
              </el-col> -->
            </el-row>

          </el-form>
          <!-- 操作按钮 -->
          <el-row type="flex" justify="space-between">
            <el-col :span="20">
              <el-button size="medium" @click="resetwScreen" v-if="showView"> 重置 </el-button>
              <el-button size="medium" @click="submitwScreen"> 查询 </el-button>

            </el-col>
            <div>
              <el-button type="primary" @click="addGoods" v-if="showView">添加商品</el-button>
            </div>

          </el-row>
        </div>
      </el-card>
    </div>
    <!-- 商品列表区域 -->
    <div class="wGoodsList-area">
      <!-- 数据列表 -->
      <div class="wGL-goods">
        <div class="wGLG-table">
          <el-table :data="tableGoods" border style="width: 100%;">
            <el-table-column label="商品名称" prop="name"> </el-table-column>
            <el-table-column label="商品唯一键" prop="goodsUniqueKey" align="center" width="140" />
            <el-table-column label="商品分类" prop="categoryId" align="center" width="140">
              <template slot-scope="scope">
                <div v-for="(item, index) in goodsCategory" :key="index" v-if="scope.row.categoryId == item.value">
                  {{ item.label }}</div>
              </template>
            </el-table-column>
            <el-table-column label="商品类型" align="center" width="140">
              <template slot-scope="scope">
                <div v-for="(item, index) in goodsType" :key="index" v-if="scope.row.atype  == item.value">{{ item.label
                  }}
                </div>
              </template>
            </el-table-column>
            <el-table-column label="店铺" prop="storeId">
              <template slot-scope="scope">
                <div v-for="(item, index) in optionsStore" :key="index" v-if="scope.row.storeId == item.value">
                  {{ item.label }}</div>
              </template>
            </el-table-column>
            <el-table-column label="图片" width="100" align="center">
              <template slot-scope="scope">
                <template v-if="isImage(scope.row.headImg[0])">
                  <el-image
                    style="width:80px;height:80px;"
                    fit="contain"
                    :src="scope.row.headImg[0]"
                    :preview-src-list="[scope.row.headImg]"
                  ></el-image>
                </template>
                <template v-else-if="isVideo(scope.row.headImg[0])">
                  <video
                    muted
                    autoplay="autoplay"
                    loop="loop"
                    style="width:80px;height:80px;"
                    fit="contain"
                    :src="scope.row.headImg[0]"
                    :preview-src-list="[scope.row.headImg]"
                  ></video>
                </template>
              </template>
            </el-table-column>

            <el-table-column label="价格" prop="retailPrice" width="140" align="center"></el-table-column>
            <el-table-column label="运费" prop="freight" width="140" align="center"></el-table-column>
            <el-table-column label="销量" prop="sales" width="140" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.sales">{{ scope.row.sales }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column label="排序" prop="sort" width="140" align="center"></el-table-column>
            <!-- <el-table-column label="限购数量" width="140" align="center">
              <template slot-scope="scope" v-if="scope.row.atype  == 16">
                <el-input v-model="scope.row.groupHotSaleNum" :disabled="true" v-if="scope.row.isGroupHotSale" />
                <el-input v-model="scope.row.groupHotSaleNum" type="number" :min="0" placeholder="请设置数量" v-else />
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="是否用于霸王餐" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.ifBawangcan" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.ifBawangcan ? '开启' : '关闭'" @change="changeIfBawangcan($event,scope)" />
              </template>
            </el-table-column>
            <el-table-column label="是否充值大福利" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.ifFuli" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.ifFuli ? '开启' : '关闭'" @change="changeIfFuli($event,scope)" />
              </template>
            </el-table-column> -->
            <el-table-column label="月限购" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.isGroupHotSale" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.isGroupHotSale ? '开启' : '关闭'" @change="changeIsGroupHotSale($event,scope)" />
              </template>


            </el-table-column>

            <el-table-column label="日限购" align="center" width="140">

              <template slot-scope="scope">
                <el-switch v-model="scope.row.dplimit" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.dplimit ? '开启' : '关闭'" @change="changeDplimit($event,scope)" />
              </template>


            </el-table-column>


            <el-table-column label="状态" align="center" width="140">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.state" :active-value="1" :inactive-value="0"
                  :active-text="scope.row.state ? '已上架' : '已下架'" @change="changeGoodsState(scope)" />
              </template>
            </el-table-column>
            <!-- <el-table-column label="发布时间" prop="createTime"></el-table-column> -->
            <!-- <el-table-column label="供应商联系方式" prop="supplierPhone"></el-table-column> -->
            <!-- <el-table-column label="备注" prop="remark"></el-table-column> -->
            <el-table-column label="操作" align="center" width="140" v-if="showView">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateGoods(scope)"><span>修改</span></el-button>
                <el-button type="text" size="small" @click="deleteGoods(scope)"><span>删除</span></el-button>
              </template>
            </el-table-column>
            <!-- <el-table-column label="满减免单" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isExplosiveProducts&&scope.row.topPrice&&scope.row.decsPrice ? 'success' : 'danger'">
                  {{ scope.row.isExplosiveProducts&&scope.row.topPrice&&scope.row.decsPrice  ? "满"+scope.row.topPrice+'元减'+scope.row.decsPrice+"元" : '否' }}
                </el-tag>
              </template>
            </el-table-column> -->
            <!-- <el-table-column label="半价优惠" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isBanjiaProducts ? 'success' : 'danger'">
                  {{ scope.row.isBanjiaProducts ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column>
            <el-table-column label="会员免费" align="center" width="120">
              <template slot-scope="scope">
                <el-tag :type="scope.row.isVipFreeProducts ? 'success' : 'danger'">
                  {{ scope.row.isVipFreeProducts ? '是' : '否' }}
                </el-tag>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="wPagination">
          <el-pagination @current-change="changePaginationCurrent" @size-change="changePaginationSize"
            :current-page="pagination.current" :page-sizes="pagination.sizes" :page-size="pagination.size"
            :total="pagination.total" layout="total, sizes, prev, pager, next, jumper">
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 添加商品 -->
    <el-dialog width="1200px" style="height: auto;"  append-to-body :title="title" :visible.sync="visibleAddGoods"
      :close-on-press-escape="false" :close-on-click-modal="false">
      <el-form style="height: 580px;overflow-y: auto;" :rules="rulesAddGoods" ref="formAddGoods" :model="formAddGoods" label-width="80px">
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品类型" prop="atype ">
              <el-select v-model="formAddGoods.atype " placeholder="请选择商品类型" @change="changeSupplyCategory" clearable
                style="width: 100%;">
                <el-option v-for="(item, index) in goodsType" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="所在门店" prop="storeId">
              <el-select v-model="formAddGoods.storeId" placeholder="请选择门店" clearable @change="changeSelectStoreId"
                style="width: 100%;">
                <el-option v-for="(item, index) in optionsStore" :key="item.value" :label="item.label"
                  :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品分类" prop="categoryId">
              <el-select v-model="formAddGoods.categoryId" :placeholder="placeholderCategory" clearable
                @change="changeSelectCategory" :disabled="disabledCategory" style="width: 100%;">
                <el-option v-for="item in optionsCategory" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品售价" prop="retailPrice">
              <el-input v-model="formAddGoods.retailPrice" type="number" placeholder="请输入商品售价" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商品名称" prop="name">
              <el-input v-model="formAddGoods.name" type="text" placeholder="请输入商品名称" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="商品序号" prop="sort">
              <el-input v-model="formAddGoods.sort" type="number" placeholder="请输入商品序号" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="整体排序" prop="sort">
              <el-input v-model="formAddGoods.reorder" type="number" placeholder="请输入排序" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="描述" prop="brand">
              <el-input v-model="formAddGoods.brand" type="text" placeholder="请输入描述"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="信用积分" prop="score">
                <el-input v-model="formAddGoods.score" type="number" placeholder="" maxlength="8"></el-input>

            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="金豆" prop="jingdou">
              <el-input v-model="formAddGoods.jingdou" type="number" placeholder="" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row :gutter="24">


          <el-col :span="24">
            <el-form-item  label="商品规格" prop="unit"  v-for="(item,i) in unnits" :key="i">

              <div class="unitBox">
                <div class="unitTop">

                    <el-input 
                      v-model="item.unitNum" 
                      type="text" 
                      placeholder="请输入规格" 
                      style="width:388px"
                      class="input"
                      >
                    </el-input>
                    <el-select 
                      v-model="item.unit" 
                      placeholder="请选择或输入单位" 
                      class="input"
                      style="width:200px"
                      filterable 
                      allow-create  
                      reserve-keyword  
                    >
                      <el-option 
                        v-for="(option, index) in optionsUnits" 
                        :key="option.value"  
                        :value="option.value"
                      />
                    </el-select>
                  
                    <div class="goodsItem">
                      <span class="span spankc" >
                        库存
                      </span>
                      <el-input  class="input inputprice" 
                        v-model="item.stock" type="number"  
                        maxlength="8"
                        style="width: 97px;"
                        >
                      </el-input>
                    </div>
                </div>

                <div class="unitBottom">

                  <div class="pricebox">
                 
                    <div class="goodsItem">
                      <span class="span">
                        顾客价
                      </span>
                      <el-input  class="input inputprice" 
                        v-model="item.price" type="number"  
                        maxlength="8"
                       
                        >
                      </el-input>
                    </div>

                    <div class="goodsItem">
                      <span class="span">
                        会员价
                      </span>
                      <el-input  class="input inputprice" 
                        v-model="item.membershipPrice" type="number"  
                        maxlength="8">
                      </el-input>
                    </div>
                    <div class="goodsItem">
                      <span class="span">
                        VIP价
                      </span>
                      <el-input  class="input inputprice" 
                      v-model="item.vipPrice" 
                      type="number" 
                        maxlength="8">
                      </el-input>
                    </div>
                    <div class="goodsItem">
                      <span class="span">
                        轻创价
                      </span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.qcPrice" 
                        type="number"
                      
                        maxlength="8"
                        >
                      </el-input>
                    </div>
                    <div class="goodsItem">
                      <span class="span">
                        社区团长价
                      </span>
                      <el-input  
                        class="input inputprice" 
                        v-model="item.communityLeaderPrice" 
                        type="number"  
                       
                        maxlength="8"
                      >
                      </el-input>
                    </div>
					<div class="goodsItem">
					  <span class="span">
					    运费
					  </span>
					  <el-input  
					    class="input inputprice" 
					    v-model="item.shipcost" 
					    type="number"  
					   
					    maxlength="8"
					  >
					  </el-input>
					</div>
                  </div>
  
  
                  
                  <el-button 
                    class="but butdel"
                    @click="reduce(i)"
                    v-if="i>=1"
                  >
                    - 删除
                  </el-button>
                </div>


              </div>
              <el-button 
                class="addbutb"
                @click="addUnit"
                v-if="i==unnits.length-1"
              >
                  + 添加
                </el-button>


            </el-form-item>
          </el-col>
                <!-- Add this after the freight input row -->
        
          <!-- <el-col :span="5">
            <el-form-item label="满减免单">
              <el-switch 
                v-model="formAddGoods.isExplosiveProducts"
                :active-value="1"
                :inactive-value="0"
                @change="val => handleSwitchChange('isExplosiveProducts', val)">
              </el-switch>
            </el-form-item>
          </el-col> -->

          <!-- 满减免单设置 - 当开关开启时显示 -->
          <!-- <template v-if="formAddGoods.isExplosiveProducts">
            <el-col :span="12">
              <el-form-item label="满减条件" prop="topPrice">
                <el-input 
                  v-model="formAddGoods.topPrice" 
                  type="number" 
                  placeholder="请输入满减金额条件" 
                  maxlength="8">
                  <template slot="prepend">满</template>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="减免金额" prop="decsPrice">
                <el-input 
                  v-model="formAddGoods.decsPrice" 
                  type="number" 
                  placeholder="请输入减免金额" 
                  maxlength="8">
                  <template slot="prepend">减</template>
                  <template slot="append">元</template>
                </el-input>
              </el-form-item>
            </el-col>
          </template> -->
        </el-row>
        <el-row :gutter="24" style="margin-left: 0px;">

          <!-- <el-col :span="5">
            <el-form-item label="半价优惠">
              <el-switch 
                v-model="formAddGoods.isBanjiaProducts" 
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="会员免费">
              <el-switch 
                v-model="formAddGoods.isVipFreeProducts" 
                :active-value="1"
                :inactive-value="0">
              </el-switch>
            </el-form-item>
          </el-col> -->



          <el-col :span="24">
            <el-form-item label="商品简介" prop="details">
              <quill-editor
                ref="quillEditor"
                v-model="formAddGoods.details"
                :options="editorOptions"
                style="height: 200px; margin-bottom: 100px;"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="0">
          <el-col :span="24">
            <el-form-item label-width="0">
              <div class="goods-attr-line">
                <span class="attr-label">七天无理由退货</span>
                <el-checkbox v-model="formAddGoods.noreason" :true-label="1" :false-label="0"></el-checkbox>
                <span class="attr-label">品质严保</span>
                <el-checkbox v-model="formAddGoods.prem" :true-label="1" :false-label="0"></el-checkbox>
                <span class="attr-label">急速退款</span>
                <el-checkbox v-model="formAddGoods.instantrefund" :true-label="1" :false-label="0"></el-checkbox>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="配送" prop="freight">

                <el-radio-group v-model="freightValue" >
                    <el-radio label="z">自提</el-radio>
                    <el-radio label="w">快递</el-radio>
                    <el-radio label="a">均可以</el-radio>
                </el-radio-group>

            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="24" v-if="freightValue=='w' || freightValue=='a'">
          <el-col :span="12">
            <el-form-item label="运费金额" prop="freight">
              <el-input v-model="formAddGoods.freight" type="number" placeholder="请输入运费" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

         <el-row :gutter="24">
            <el-col :span="12">
            <el-form-item label="菜品类型">
              <el-select
                v-model="formAddGoods.dishType"
                placeholder="请选择菜品类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="item in storeTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
         </el-row>

         <el-row :gutter="24">
            <el-col :span="12">
            <el-form-item label="销售佣金">
              <el-input 
                v-model="formAddGoods.salecomm" 
                placeholder="销售佣金" 
                maxlength="50"
                class="input"
                type="number"
              />
            </el-form-item>
          </el-col>

         </el-row>
         <!-- <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="是否用于霸王餐" label-width="80">
              <el-switch 
                v-model="formAddGoods.ifBawangcan"
                :active-value="1"
                :inactive-value="0"
                :active-text="'开启'"
                :inactive-text="'关闭'">
              </el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="是否充值大福利" label-width="80">
              <el-switch 
                v-model="formAddGoods.ifFuli"
                :active-value="1"
                :inactive-value="0"
                :active-text="'开启'"
                :inactive-text="'关闭'">
              </el-switch>
            </el-form-item>
          </el-col>
         </el-row> -->
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="国补折扣">
              <el-input 
                v-model="formAddGoods.discount" 
                placeholder="国补折扣" 
                maxlength="50"
                class="input"
                type="number"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="公司分佣" >
              <!-- <input v-model="commission" type="txt" placeholder="软件公司分佣" maxlength="30"/> -->

              <el-input 
              v-model="commission" 
            
              placeholder="软件公司分佣" 

            
              maxlength="50"
              class="input"
              >
            </el-input>

            </el-form-item>
          </el-col>

         

        </el-row>

        <!-- <el-row :gutter="24" v-if="onShowSkuList">
          <el-col :span="6">
            <el-form-item :label="`规格${index + 1}`" label-width="48px" prop="'name'"
              v-for="(item, index) in formAddGoods.skuList" :key="item.key">
              <el-input v-model="item.name" type="text" placeholder="请输入规格名称" maxlength="30"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="原价" label-width="40px" prop="'membershipPrice'"
              v-for="(item, index) in formAddGoods.skuList" :key="item.key">
              <el-input v-model="item.membershipPrice" type="number" placeholder="原价" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="现价" label-width="40px" prop="'price'" v-for="(item, index) in formAddGoods.skuList"
              :key="item.key">
              <el-input v-model="item.price" type="number" placeholder="现价" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="vip价" label-width="45px" prop="'vipPrice'"
              v-for="(item, index) in formAddGoods.skuList" :key="item.key">
              <el-input v-model="item.vipPrice" type="number" placeholder="vip价" maxlength="8"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="'库存'" label-width="40px" prop="'stock'" class="specification"
              v-for="(item, index) in formAddGoods.skuList" :key="item.key">
              <el-input v-model="item.stock" type="number" placeholder="库存" maxlength="8">
              </el-input>
              <el-button @click.prevent="removeSpecification(item)">删除</el-button>
            </el-form-item>
          </el-col>
          <el-col>
            <el-form-item>
              <el-button type="primary" @click="addSpecification">添加规格</el-button>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row :gutter="24">
          <el-col >
            <el-form-item label="商品主图" prop="headImg">
              <el-upload 
                ref="mainUpload" 
                list-type="picture-card" 
                :limit="limitMainImg" 
                :file-list="mainFileList"
                :class="{ hide: hideMainUpload }" 
                :action="getUploadUrl()" 
                :before-upload="uploadBefore"
                :on-success="uploadSuccessMain" 
                :on-remove="uploadRemoveMain" 
                :show-file-list="true"
                >
                <i class="el-icon-plus"></i>
                
                <!-- 自定义文件列表项 -->
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <!-- 图片预览 -->
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]">
                    </el-image>
                    
                    <!-- 视频预览 -->
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url">
                    </video>
                    
                    <!-- 删除按钮 -->
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'zt')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>

              <!-- 自定义展示文件列表 -->
              <!-- <div class="custom-file-list">
                <div v-for="(item, index) in mainFileList" :key="index" class="file-item">
                  <template v-if="isImage(item.url)">
                    <img :src="item.url" class="preview-img" />
                  </template>
                  <template v-else-if="isVideo(item.url)">
                    <video :src="item.url" class="preview-video" controls />
                  </template>
                </div>
              </div> -->

            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col>
            <el-form-item label="商品配图">
              <el-upload 
              ref="nextUpload" 
              list-type="picture-card" 
              :limit="limitNextImg" 
              :file-list="nextFileList"
              :class="{ hide: hideNextUpload }" 
              :action="getUploadUrl()" 
              :before-upload="uploadBefore"
              :on-success="uploadSuccessNext" 
              :on-remove="uploadRemoveNext" 
              :show-file-list="true"
              >
                <i class="el-icon-plus"></i>
                <!-- 自定义文件列表项 -->
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <!-- 图片预览 -->
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]">
                    </el-image>
                    
                    <!-- 视频预览 -->
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url">
                    </video>
                    
                    <!-- 删除按钮 -->
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'pt')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>

              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="24">
          <el-col >
            <el-form-item label="经营资质" prop="qualification">
              <el-upload 
                ref="qualificationUpload" 
                list-type="picture-card" 
                :limit="limitQualificationImg" 
                :file-list="qualificationFileList"
                :class="{ hide: hideQualificationUpload }" 
                :action="getUploadUrl()" 
                :before-upload="uploadBefore"
                :on-success="uploadSuccessQualification" 
                :on-remove="uploadRemoveQualification" 
                :show-file-list="true"
                >
                <i class="el-icon-plus"></i>
                <template #file="{ file }">
                  <div class="custom-upload-item">
                    <el-image
                      v-if="isImage(file.url)"
                      style="width:100%;height:100%;"
                      fit="contain"
                      :src="file.url"
                      :preview-src-list="[file.url]">
                    </el-image>
                    <video
                      v-else-if="isVideo(file.url)"
                      controls
                      style="width:100%;height:100%;object-fit:contain;"
                      :src="file.url">
                    </video>
                    <span class="el-upload-list__item-actions">
                      <span class="el-upload-list__item-delete" @click="handleRemove(file,'qualification')">
                        <i class="el-icon-delete"></i>
                      </span>
                    </span>
                  </div>
                </template>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleAddGoods = false">取 消</el-button>
        <el-button type="primary" @click="submitAddGoods('formAddGoods')">提 交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getClassify, getSupplyOptions } from "@/network/api.js";
import { goods_GCEditGoods, goods_GCAddGoods, goods_GCRemoveGoodsById, 
         goods_GCGetGoodsInfo, pub_fileUpload_file, changeGroupHotSaleApi,changedplimitSaleApi, changeIfBawangcanApi, changeIfFuliApi } from '@/network/wApi';
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import Delta from 'quill-delta';

// 自定义视频Blot
const VideoBlot = {
  init() {
    const Quill = this.$refs.quillEditor?.quill?.constructor;
    if (!Quill) return;

    const VideoFormat = Quill.import('formats/video');
    
    class CustomVideoBlot extends VideoFormat {
      static create(value) {
        const node = super.create(typeof value === 'object' ? value.url : value);
        node.setAttribute('controls', 'controls');
        node.setAttribute('style', 'max-width:100%; height:auto; display:block;');
        
        if (typeof value === 'object' && value.id) {
          node.innerHTML = `
            <div style="width:100%;height:200px;background:#f5f5f5;
                       display:flex;align-items:center;justify-content:center;color:#999;">
              视频上传中...
            </div>`;
        }
        return node;
      }

      static value(node) {
        return node.src;
      }
    }
    
    Quill.register(CustomVideoBlot, true);
  }
};

export default {
  components: {
    quillEditor
  },
  data() {
    return {
      commission:'',
      freightValue:"",
      // 商品筛选表单
      wScreen: {
        search: null,             // 关键字
        categoryId: null,         // 商品分类
        state: null,              // 商品状态
        storeId: null,
        goodType:1,        // 所属店铺
        pageNo: 1,
        goodsUniqueKey: null,  // 新增
        ifBawangcan: 0,     // 是否霸王餐
        ifFuli: 0,          // 是否充值大福利

        pageSize: 20,
        "pageModel.pageNo": 1,
        "pageModel.pageSize": 20
      },

      editorOptions: {
        modules: {
          toolbar: {
            container: [
              ['bold', 'italic', 'underline', 'strike'],
              ['blockquote', 'code-block'],
              [{ 'header': 1 }, { 'header': 2 }],
              [{ 'list': 'ordered' }, { 'list': 'bullet' }],
              [{ 'script': 'sub' }, { 'script': 'super' }],
              [{ 'indent': '-1' }, { 'indent': '+1' }],
              [{ 'direction': 'rtl' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'font': [] }],
              [{ 'align': [] }],
              ['clean'],
              ['link', 'image', 'video']
            ],
            handlers: {
              video: this.handleVideoUpload.bind(this)
            }
          }
        },
        placeholder: '请输入商品简介...',
        theme: 'snow'
      },
      // 商品所属店铺options
      optionsStore: [],
      clearableStoreId: true, // 是否可清空
      disabledStoreId: false, // 是否禁用
      // 商品分类options
      optionsCategory: [],
      placeholderCategory: "请先选择商品类型和门店",
      disabledCategory: true, // 是否禁用
      // 商品状态options
      optionsState: [{ label: "全部", value: "" }, { label: "已上架", value: "1" }, { label: "未上架", value: "0" }],
      storeTypeOptions: [
        { label: "全牛小面", value: "QNXM" },
        { label: "非遗酸汤火锅", value: "FYST" },
        { label: "香辣牛骨锅", value: "XLNG" },
        { label: "韩式烤肉", value: "HSKR" },
        { label: "牧歌烧烤", value: "MGSK" },
        { label: "广式烤鸭(饭)", value: "GSKY" },
        { label: "美式炸鸡", value: "MSZJ" },
        { label: "牧歌牛包子", value: "MGBZ" },
        { label: "铜锅涮肉", value: "TGSR" },
        { label: "辣辣卤鸭货", value: "LLYH" },
        { label: "重庆毛肚火锅", value: "CQHG" },
        { label: "社区卤菜厨房", value: "SQCF" }
      ],

      // 商品类型
      goodsType: [
        // { label: "堂食商品", value: 1 },
        // { label: "供应链商品", value: 3 }
      ],
      // 所有商品分类（遍历商品列表中对应的分类id）
      goodsCategory: [],
      // 商品数据列表
      tableGoods: [],
      // 分页配置
      pagination: {
        current: 1,
        size: 20,
        sizes: [10, 20, 50, 100],
        total: 0
      },

      // 添加&修改 商品
      title: "",                // 标题
      visibleAddGoods: false,   // 弹出层状态
      visibleSupply: false,     // 是否选择商品类型
      formAddGoods: {           // 表单
        salecomm:0,
        discount:0,
        dishType: "",
        storeId: "",
        categoryId: "",
        name: "",
        retailPrice: "",
        atype : "",
        sort: "",
        unit: "",
        brand: "",
        details: "",
        headImg: "",
        skuList:null,
        reorder: null,
        imgList: [],
                goodType: 1,     // 是否为会员免费产品
        freight: 0,
        isExplosiveProducts: 0,  // 是否为满减免单产品
        isBanjiaProducts: 0,     // 是否为半价优惠产品
        isVipFreeProducts: 0,     // 是否为会员免费产品
        noreason: 0,              // 七天无理由退货
        prem: 0,                  // 品质严保
        instantrefund: 0,         // 急速退款
              topPrice: null,          // 满减条件金额
      decsPrice: null
      },
      onShowSkuList: false,
      // 表单校验
      rulesAddGoods: {
          // topPrice: [
          //   { 
          //     required: true, 
          //     message: '请输入满减条件金额', 
          //     trigger: 'blur',
          //     validator: (rule, value, callback) => {
          //       if (this.formAddGoods.isExplosiveProducts && !value) {
          //         callback(new Error('请输入满减条件金额'));
          //       } else {
          //         callback();
          //       }
          //     }
          //   }
          // ],
          // decsPrice: [
          //   { 
          //     required: true, 
          //     message: '请输入减免金额', 
          //     trigger: 'blur',
          //     validator: (rule, value, callback) => {
          //       if (this.formAddGoods.isExplosiveProducts && !value) {
          //         callback(new Error('请输入减免金额'));
          //       } else {
          //         callback();
          //       }
          //     }
          //   }
          // ],
        storeId: [{ required: true, message: '请选择所属门店', trigger: 'blur' }],
        // categoryId: [{ required: true, message: '请选择商品分类', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商品名称', trigger: 'blur' }],
        retailPrice: [{ required: true, message: '请输入商品售价', trigger: 'blur' }],
        atype : [{ required: true, message: '请选择商品类型', trigger: 'blur' }],
        sort: [{ required: true, message: '请输入商品排序', trigger: 'blur' }],
        // unit: [{ required: true, message: '请选择商品规格', trigger: 'blur' }],
        // details: [{ required: true, message: '请输入商品简介', trigger: 'blur' }],
        headImg: [{ required: true, message: '请上传商品主图', trigger: 'blur' }],
          isExplosiveProducts: [{ required: false }],
          isBanjiaProducts: [{ required: false }],
          isVipFreeProducts: [{ required: false }]
      },
      optionsUnits: [           // 商品规格下拉框
        { label: "份", value: "份" },
        { label: "位", value: "位" },
        { label: "锅", value: "锅" },
        { label: "碗", value: "碗" },
        { label: "盒", value: "盒" },
        { label: "个", value: "个" },
        { label: "套", value: "套" },
        { label: "双", value: "双" },
        { label: "提", value: "提" },
        { label: "捆", value: "捆" },
        { label: "条", value: "条" },
        { label: "根", value: "根" },
        { label: "盘", value: "盘" },
        { label: "桶", value: "桶" },
        { label: "包", value: "包" },
        { label: "袋", value: "袋" },
        { label: "件", value: "件" },
        { label: "箱", value: "箱" },
        { label: "罐", value: "罐" },
        { label: "瓶", value: "瓶" },
        { label: "吨", value: "吨" },
        { label: "斤", value: "斤" },
        { label: "两", value: "两" },
        { label: "克", value: "克" },
        { label: "升", value: "升" },
        { label: "串", value: "串" },
      ],
      unitNum: 1,
      goodsUnit: "份",

      mainFileList: [],         // 主图
      limitMainImg: 5,          // 上传数量限制
      hideMainUpload: false,    // 是否隐藏上传按钮
      qualificationFileList: [], // 经营资质
      limitQualificationImg: 99999,  // 上传数量限制
      hideQualificationUpload: false, // 是否隐藏上传按钮

      nextFileList: [],         // 详情图
      limitNextImg: 4,          // 上传数量限制
      hideNextUpload: false,    // 是否隐藏上传按钮
      // 操作按钮
      showView: false,
      disabledGoods: true,

      // price，membershipPrice，vipPrice，qcPrice，communityLeaderPrice，//商品价格

      unnits:[
        {
          membershipPrice:0,//会员价
          vipPrice:0,//VIP价
          qcPrice:0,//轻创价格价
          communityLeaderPrice:0,//社区团长价
		  shipcost: 0,//运费
          price:0,//顾客价
          unitNum:"",//数量
          stock:"",//库存
          unit:"",//单位
        }
      ]//商品规格
    };
  },
  created() {
    this.changePermission()
  },
  mounted() {
    this.initVideoBlot();
  },
watch:{
  freightValue(newValue){
    console.log(newValue);

  }
},
  methods: {
    freightchanage(){
          console.log(this.freightValue)

    },  
      handleRemove(file,type) {
      let index;
      const arr=type=='zt'?this.mainFileList:this.nextFileList;
      index = arr.findIndex(f => f.url === file.url);
      if(type=='zt'){
        if (index !== -1) {
          this.mainFileList.splice(index, 1);
          this.formAddGoods.headImg.splice(index, 1);
          this.hideMainUpload = false;
    
        }
      }else{
        if (index !== -1) {
          this.nextFileList.splice(index, 1);
          this.formAddGoods.imgList.splice(index, 1);
          this.hideNextUpload = false;

        
        }
      }
  },
    handleSwitchChange(field, val) {
    // 强制更新表单数据
    this.$set(this.formAddGoods, field, val)
    console.log(`${field} changed to:`, val)
  },
  initVideoBlot() {
      this.$nextTick(() => {
        if (this.$refs.quillEditor) {
          VideoBlot.init.call(this);
        }
      });
    },
    handleVideoUpload() {
      const input = document.createElement('input');
      input.type = 'file';
      input.accept = 'video/*';
      
      input.onchange = async () => {
        const file = input.files[0];
        if (!file) return;
        
        // 验证文件类型和大小
        const validTypes = ['video/mp4', 'video/webm', 'video/ogg'];
        if (!validTypes.includes(file.type)) {
          this.$message.error('仅支持MP4/WebM/OGG格式视频');
          return;
        }
        
        if (file.size > 50 * 1024 * 1024) {
          this.$message.error('视频大小不能超过50MB');
          return;
        }
        
        const quill = this.$refs.quillEditor.quill;
        const range = quill.getSelection();
        const placeholderId = `video-${Date.now()}`;
        
        // 插入占位符
        quill.insertEmbed(range.index, 'video', {
          id: placeholderId,
          url: 'about:blank'
        }, 'user');
        
        try {
          const loading = this.$loading({
            lock: true,
            text: '视频上传中...',
            spinner: 'el-icon-loading',
            background: 'rgba(0,0,0,0.7)'
          });
          
          const formData = new FormData();
          formData.append('file', file);
          
          const res = await pub_fileUpload_file(formData);
          loading.close();
          
          if (res) {
            this.replaceVideoPlaceholder(placeholderId, res);
            this.$message.success('视频上传成功');
          } else {
            throw new Error(res.message || '上传失败');
          }
        } catch (error) {
          this.$message.error(`视频上传失败: ${error.message}`);
          this.removeVideoPlaceholder(placeholderId);
        }
      };
      
      input.click();
    },
  registerVideoBlot() {
    const Quill = this.$refs.quillEditor.quill.constructor;
    
    class VideoBlot extends Quill.import('formats/video') {
      static create(value) {
        // 处理上传中和最终URL两种情况
        const url = typeof value === 'object' ? value.url : value;
        const node = super.create(url);
        
        // 设置视频属性
        node.setAttribute('controls', 'controls');
        node.setAttribute('style', 'max-width:100%; height:auto; display:block;');
        
        // 如果是占位符，添加特殊样式
        if (typeof value === 'object' && value.id) {
          node.innerHTML = `
            <div style="
              width:100%; 
              height:200px; 
              background:#f5f5f5;
              display:flex;
              align-items:center;
              justify-content:center;
              color:#999;
            ">
              视频上传中...
            </div>
          `;
        }
        
        return node;
      }

      static value(node) {
        return node.src;
      }
    }
    
    Quill.register(VideoBlot, true);
  },
  
  replaceVideoPlaceholder(id, url) {
  const quill = this.$refs.quillEditor.quill;
  const length = quill.getLength();
  
  // 从后向前查找更高效
  for (let i = length - 1; i >= 0; i--) {
    const ops = quill.getContents(i, 1).ops;
    if (ops[0]?.insert?.video?.id === id) {
      quill.deleteText(i, 1, 'silent');
      quill.insertEmbed(i, 'video', url, 'user');
      return true;
    }
  }
  
  // 未找到则插入到末尾
  quill.insertEmbed(length, 'video', url, 'user');
  return false;
},
  
    removeVideoPlaceholder(id) {
      const quill = this.$refs.quillEditor.quill;
      const contents = quill.getContents();
      let position = 0;
      
      for (const op of contents.ops) {
        if (op.insert?.video?.id === id) {
          quill.deleteText(position, 1, 'user');
          return;
        }
        position += this.getOpLength(op);
      }
    },
    getOpLength(op) {
      if (op.insert) {
        if (typeof op.insert === 'string') {
          return op.insert.length;
        }
        return 1; // 嵌入内容（如图片、视频）算1个长度
      }
      return 0;
    },
    // 权限判断
    changePermission() {
      const userInfo = JSON.parse(localStorage.getItem('USER_INFO'))
      if (userInfo.roleId == 7) {
        console.log("门店账户")
        this.showView = false
        this.clearableStoreId = false             // 是否可清空
        this.disabledStoreId = true               // 是否禁用
        this.disabledCategory = false             // 开启分类下拉框状态
        this.wScreen.storeId = userInfo.storeId   // 门店id筛选参数
        this.getOptionsCategoryAll()              // 获取所有门店商品分类
        this.getSupplyOptionsAll()                // 获取所有商品类型
        this.getOptionsStore()                    // 获取门店列表
        this.getOptionsCategory(userInfo.storeId) // 获取门店分类
        this.getGoodsData(this.wScreen)           // 获取商品数据
      } else {
        console.log("非门店账户")
        this.showView = true
        this.getOptionsCategoryAll()  // 获取所有门店商品分类
        this.getSupplyOptionsAll()    // 获取所有商品类型
        this.getOptionsStore()        // 获取门店列表
        this.getGoodsData(this.wScreen)           // 获取商品列表
      }
    },
    /**
     * 获取商品数据
    */
    getGoodsData(e) {
      // 补充外层的分页参数
      e.pageNo = e["pageModel.pageNo"] || this.pagination.current || 1;
      e.pageSize = e["pageModel.pageSize"] || this.pagination.size || 20;
      console.log("请求参数", e);
      
      this.$api.goods_GCList({
        data: e,
        success: res => {
          console.log("商品列表", res.records)

          for (let id = 0; id < res.records.length; id++) {
            const element = res.records[id];
            // 手动处理非标准字符串
            let headImgArray = [];
            if (element.headImg) {
                const trimmedStr = element.headImg.slice(1, -1); // 去除方括号
                if (trimmedStr) {
                    headImgArray = trimmedStr.split(',');
                }
            }
            element.headImg = headImgArray || null;
          }
          this.tableGoods = res.records
          
          this.pagination.total = res.total !== undefined ? res.total : (res.count || (res.records ? res.records.length : 0))
        }
      })
    },


    
    /**
     * 获取门店数据
    */
    getOptionsStore() {
      let obj = {
        "pageModel.pageNo": 1,
        "pageModel.pageSize": 2000,
        goodType:1
      }
      this.$api.store_list({
        data: obj,
        success: res => {
          // console.log("门店列表", res.records)
          let ary = []
          for (let i = 0; i < res.records.length; i++) {
            const item = {
              label: res.records[i].storeName,
              value: res.records[i].id
            }
            ary.push(item)
          }
          this.optionsStore = ary
        }
      })
    },
    /**
     * 获取分类列表
    */
    getOptionsCategoryAll() {
      // 获取所有分类(用于遍历商品列表数据分类对应名称)
      this.$api.goods_GCGetCategory({
        success: res => {
          let ary = []
          for (let i = 0; i < res.length; i++) {
            const item = {
              label: res[i].name,
              value: res[i].id
            }
            ary.push(item)
          }
          this.goodsCategory = ary
        }
      })
    },
    /**
     * 获取商品类型列表
     */
    getSupplyOptionsAll() {
      // 获取所有分类(用于遍历商品类型数据分类对应名称)
      getSupplyOptions().then(res => {
        console.log(res);
        let ary = []
        for (let i = 0; i < res.length; i++) {
          const item = {
            label: res[i].name,
            value: res[i].id
          }
          ary.push(item)
        }
        this.goodsType = ary
      })
    },
    getOptionsCategory(e) {
      let obj = { storeId: e }
      // 根据门店获取
      getClassify(obj).then(res => {
        let ary = []
        for (let i = 0; i < res.length; i++) {
          const item = {
            label: res[i].name,
            value: res[i].id
          }
          ary.push(item)
        }
        this.optionsCategory = ary
      })
    },

    /**
     * 筛选下拉框
    */
    changeInputSearch(e) {
      this.submitwScreen()
    },
    changeSupplyCategory(e) {
      console.log(e);
      this.onShowSkuList = true
      if (e == 16) {
        this.visibleSupply = true
        this.onShowSkuList = false
      }
    },
    changeSelectStoreId(e) {      // 选择商品所属店铺
      console.log("门店", e)
      // 如果门店id不存在，并且弹出层为false
      if (!e && this.visibleAddGoods == false) {
        this.wScreen.categoryId = null          // 筛选分类id赋为null
        this.placeholderCategory = "请先选择门店"
        this.disabledCategory = true             // 禁用分类选择下拉框
        this.submitwScreen()                    // 请求提交筛选
      }
      // 如果门店id不存在，并且弹出层为true
      if (!e && this.visibleAddGoods == true && this.visibleSupply) {
        this.formAddGoods.categoryId = null     // 筛选分类id赋为null
        this.placeholderCategory = "请先选择门店和商品类型"
        this.disabledCategory = true             // 禁用分类选择下拉框
      }
      // 如果门店id存在，并且弹出层为false
      if (e && this.visibleAddGoods == false) {
        this.wScreen.categoryId = null
        this.placeholderCategory = "请选择分类"
        this.disabledCategory = false           // 开启分类选择下拉框
        this.getOptionsCategory(e)              // 获取这个门店的分类
        this.submitwScreen()                    // 请求提交筛选
      }
      // 如果门店id存在，并且弹出层为true
      if (e && this.visibleAddGoods == true && this.visibleSupply == false) {
        this.formAddGoods.categoryId = null     // 筛选分类id赋为null
        this.placeholderCategory = "只有堂食商品才需要分类"
        this.disabledCategory = true           // 开启分类选择下拉框
      }
      if (e && this.visibleAddGoods == true && this.visibleSupply == true) {
        this.formAddGoods.categoryId = null     // 筛选分类id赋为null
        this.placeholderCategory = "请选择分类"
        this.disabledCategory = false           // 开启分类选择下拉框
        this.getOptionsCategory(e)              // 获取这个门店的分类
      }
    },

    changeSelectCategory(e) {     // 选择商品分类
      this.submitwScreen()
    },

    changeSelectState(e) {        // 选择商品状态
      this.submitwScreen()
    },


    /**
     * 筛选操作
    */
    // 重置筛选表单
    resetwScreen() {
      this.resetPagination()          // 重置分页参数
      this.wScreen.search = null,     // 关键字
        this.wScreen.storeId = null,    // 所属店铺
        this.wScreen.categoryId = null, // 商品分类
        this.wScreen.state = null,      // 商品状态
        this.wScreen.ifBawangcan = null,// 是否霸王餐
        this.wScreen.ifFuli = null,     // 是否充值大福利
        this.wScreen["pageModel.pageNo"] = this.pagination.current
      this.wScreen["pageModel.pageSize"] = this.pagination.size

      this.placeholderCategory = "请先选择门店"
      this.disabledCategory = true
      this.getGoodsData(this.wScreen)
    },
    // 提交筛选表单
    submitwScreen() {
      if (this.visibleAddGoods == false) {
        this.resetPagination()        // 重置分页参数
        this.wScreen["pageModel.pageNo"] = this.pagination.current
        this.wScreen["pageModel.pageSize"] = this.pagination.size
        this.getGoodsData(this.wScreen)
      }
    },
    /**
     * 商品数据操作
    */
    changeGoodsState(e) {     // 商品上架下架
      this.$api.goods_GCUpdateState({
        data: {
          goodsId: e.row.id
        },
        success: res => {
          // console.log("商品状态修改",res)
          if (res) {
            this.$message.success('商品上架成功')
          } else {
            this.$message.info('商品已下架')
          }
        },
      })
    },
    changeIsGroupHotSale(type,e) {

      console.log('是否限购',type,e)

      changeGroupHotSaleApi({ goodsId: e.row.id, isGroupHotSale: e.row.isGroupHotSale, groupHotSaleNum: 1 }).then(res => {
        console.log("默认", res)
      })


    },

    changeDplimit(type,e) {

      console.log('是否限购',type,e)

      changedplimitSaleApi({ goodsId: e.row.id, dplimit: e.row.dplimit}).then(res => {
        console.log("默认", res)
      })



    },

    changeIfBawangcan(type,e) {
      console.log('是否霸王餐',type,e)
      changeIfBawangcanApi({
        goodsId: e.row.id,
        ifBawangcan: e.row.ifBawangcan
      }).then(res => {
        console.log("修改霸王餐状态", res)
        this.$message.success('修改成功')
      })
    },

    changeIfFuli(type,e) {
      console.log('是否充值大福利',type,e)
      changeIfFuliApi({
        goodsId: e.row.id,
        ifFuli: e.row.ifFuli
      }).then(res => {
        console.log("修改充值大福利状态", res)
        this.$message.success('修改成功')
      })
    },

    isImage(src) {
      
      const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
      const pureSrc = src.split('?')[0]; // 去掉参数部分
      const ext = '.' + pureSrc.split('.').pop().toLowerCase();
      return imageExtensions.includes(ext);
    },
    isVideo(src) {
      const videoExtensions = ['.mp4', '.avi', '.mkv', '.flv', '.webm'];
      const ext = '.' + src.split('.').pop().toLowerCase();
      return videoExtensions.includes(ext);
    },
    resetFormAddGoods() {         // 重置表单
      this.hideMainUpload = false
      this.hideNextUpload = false
      this.hideQualificationUpload = false // 新增清理资质图按钮状态
      this.mainFileList = []
      this.nextFileList = []
      this.qualificationFileList = [] // 新增清理资质图列表
      this.unitNum = 1,
        this.goodsUnit = "份"
      this.formAddGoods = {
        storeId: null,
        categoryId: null,
        name: null,
        retailPrice: null,
        atype : null,
        sort: null,
        unit: null,
        dishType: null,
        details: null,
        headImg: [],
        reorder: null,
        commission:null,
        discount:null,
        imgList: [],
        qualification: [], // 新增重置表单字段
        freight: 0,
        score:0,
        jingdou:0,
        ifBawangcan: 0,
        ifFuli: 0,
        skuList: [{
          
        }]
      }
    },
    // 编辑商品单位选择
    changeSelectInput(e) {
      // console.log(e)
      this.formAddGoods.unit = e + this.goodsUnit.toString()
    },
    changeSelectUnit(e) {
      // console.log(e)
      this.formAddGoods.unit = this.unitNum.toString() + e
    },
    /**
     *  添加商品
    */
    addGoods() {
      this.title = "添加商品"
      this.unnits=[
      {
          membershipPrice:0,//会员价
          vipPrice:0,//VIP价
          qcPrice:0,//轻创价格价
          communityLeaderPrice:0,//社区团长价
		  shipcost:0,//运费
          price:0,//顾客价
          unitNum:"",//数量
          stock:"",//库存
          unit:"",//单位
        }
      ];
      this.resetFormAddGoods()                  // 重置表单
      // 如果筛选门店id存在
      if (this.wScreen.storeId && this.wScreen.categoryId) {
        this.formAddGoods.storeId = this.wScreen.storeId
        this.formAddGoods.categoryId = this.wScreen.categoryId
      }
      if (this.wScreen.storeId && !this.wScreen.categoryId) {
        this.formAddGoods.storeId = this.wScreen.storeId
        this.placeholderCategory = "请选择分类"
        this.disabledCategory = false            // 开启分类选择下拉框
      }
      if (!this.wScreen.storeId) {
        this.formAddGoods.categoryId = null     // 筛选分类id赋为null
        this.placeholderCategory = "请先选择门店"
        this.disabledCategory = true             // 禁用分类选择下拉框
      }
      // 填充单位表单
      this.formAddGoods.unit = this.unitNum.toString() + this.goodsUnit.toString()
      this.visibleAddGoods = true
    },
    /**
     *  修改商品
    */
updateGoods(e) {
  console.log('11111',e);
  
  this.resetFormAddGoods()
  if (e.row.state == 1) {
    this.$message.error('请先下架商品再修改！')
    return
  } else {
    this.title = "修改商品"
    goods_GCGetGoodsInfo({ goodsId: e.row.id }).then(res => {
      console.log('接口返回数据:', res)
      
      // 使用深拷贝确保响应式更新
      const formData = JSON.parse(JSON.stringify({
        id: res.id,
        atype: res.atype,
        categoryId: res.categoryId,
        details: res.details,
        name: res.name,
        retailPrice: res.retailPrice,
        sort: res.sort,
        storeId: res.storeId,
        freight: res.freight,
        salecomm:res.salecomm,
        dishType: Array.isArray(res.type) ? (res.type[0] || '') : (res.type || res.dishType || ''),
        reorder:res.reorder,
        commission:res.commission,
        brand:res.brand,
        score:res.score,
        jingdou:res.jingdou,
        discount:res.discount,
        noreason: res.noreason != null ? res.noreason : 0,
        prem: res.prem != null ? res.prem : 0,
        instantrefund: res.instantrefund != null ? res.instantrefund : 0,
        // 确保转换为数字类型
        isExplosiveProducts: res.isExplosiveProducts ? 1 : 0,
        isBanjiaProducts: res.isBanjiaProducts ? 1 : 0,
        isVipFreeProducts: res.isVipFreeProducts ? 1 : 0,
        ifBawangcan: res.ifBawangcan != null ? res.ifBawangcan : 0,
        ifFuli: res.ifFuli != null ? res.ifFuli : 0,
        skuList: res.skuList || []
      }))
      this.commission=res.commission      
      // 使用Object.assign确保响应式更新
      this.formAddGoods = Object.assign({}, this.formAddGoods, formData)
      this.freightValue=res.identity || '';
      // 处理规格数据
      if (res.skuList && res.skuList.length > 0) {
        this.unnits = res.skuList.map(item => {
          const unit = item.name.slice(-1)
          const unitNum = item.name.slice(0, -1)
          return {
            ...item,
            unit,
            unitNum
          }
        })
      }

      // 处理图片数据
      if (res.headImg) {
        const imgArray = res.headImg.slice(1, -1).split(',').map(url => url.trim())
        this.mainFileList = imgArray.map(url => ({ url }))
        this.formAddGoods.headImg = imgArray
        this.hideMainUpload = imgArray.length >= this.limitMainImg
      }

      if (res.imgList) {
        this.nextFileList = res.imgList.map(url => ({ url }))
        this.formAddGoods.imgList = res.imgList
        this.hideNextUpload = res.imgList.length >= this.limitNextImg
      }
      if (res.qualification) {
        let qualArr = []
        if (Array.isArray(res.qualification)) {
          qualArr = res.qualification
        } else if (typeof res.qualification === 'string' && res.qualification.startsWith('[')) {
          qualArr = res.qualification.slice(1, -1).split(',').map(url => url.trim())
        } else if (typeof res.qualification === 'string') {
          qualArr = [res.qualification]
        }
        this.qualificationFileList = qualArr.map(url => ({ url }))
        this.formAddGoods.qualification = qualArr
        this.hideQualificationUpload = qualArr.length >= this.limitQualificationImg
      } else {
        this.qualificationFileList = []
        this.formAddGoods.qualification = []
        this.hideQualificationUpload = false
      }

      // 处理单位数据
      if (res.unit) {
        const m = res.unit.length
        this.unitNum = res.unit.slice(0, m - 1)
        this.goodsUnit = res.unit.slice(m - 1, m)
        this.formAddGoods.unit = res.unit
      }

      this.placeholderCategory = "请选择分类"
      this.disabledCategory = false;

      
      // 强制更新视图
      this.$nextTick(() => {
        this.$forceUpdate()
        console.log('当前表单数据:', JSON.parse(JSON.stringify(this.formAddGoods)))
      })
      
      this.visibleAddGoods = true
    })
  }
},
    deleteGoods(e) {             // 删除商品
      console.log(e.row.id)
      goods_GCRemoveGoodsById({ goodsId: e.row.id }).then(res => {
        this.$message.success('删除成功！')
        this.submitwScreen()
      })
    },
    /**
     * 文件上传
    */
    getUploadUrl() { return `${process.env.VUE_APP_URE}/file/uploadFile` },
    // 上传之前的钩子
    uploadBefore(file) {
      this.loading = true
      console.log(file.type);
      
      const isJPG = file.type === 'image/jpeg'
      const isPNG = file.type === 'image/png'
      const isMp4 = file.type === 'video/mp4'
      console.log(isMp4);
      
      if (!isJPG && !isPNG&& !isMp4) {
        this.$message.error('上传图片只能是 JPG 或者 PNG 格式!')
      }
      return isJPG || isPNG||isMp4;
    },
    // 上传成功回调
    uploadSuccessMain(file, fileList) {
      let obj = { url: file.data }
      this.mainFileList.push(obj)   
      console.log(this.mainFileList);
              // push已经上传的图片
      this.formAddGoods.headImg.push(file.data) 
      if (this.mainFileList.length >= this.limitMainImg) {
        this.hideMainUpload = true          // 隐藏上传按钮
      }
      this.$refs.mainUpload.clearFiles()    // 清空上传的文件列表
    },
    uploadSuccessNext(file, fileList) {
      let obj = { url: file.data }
      this.nextFileList.push(obj)           // push已经上传的图片
      this.formAddGoods.imgList.push(file.data)
      if (this.nextFileList.length >= this.limitNextImg) {
        this.hideNextUpload = true          // 隐藏上传按钮
      }
      this.$refs.nextUpload.clearFiles()    // 清空上传的文件列表
    },
      uploadSuccessQualification(file, fileList) {
        let obj = { url: file.data }
        this.qualificationFileList.push(obj)
        if (!Array.isArray(this.formAddGoods.qualification)) {
          this.formAddGoods.qualification = []
        }
        this.formAddGoods.qualification.push(file.data)
        if (this.qualificationFileList.length >= this.limitQualificationImg) {
          this.hideQualificationUpload = true
        }
        this.$refs.qualificationUpload.clearFiles()
      },
    // 移除文件
    uploadRemoveMain(file) {
      console.log(file)
      for (let i = 0; i < this.mainFileList.length; i++) {
        if (this.mainFileList[i].url == file.url) {
          this.mainFileList.splice(i, 1)
          this.formAddGoods.headImg = null
          this.hideMainUpload = false
        }
      }
    },
    uploadRemoveNext(file) {
      console.log(file)
      for (let i = 0; i < this.nextFileList.length; i++) {
        if (this.nextFileList[i].url == file.url) {
          this.nextFileList.splice(i, 1)
          for (let j = 0; j < this.formAddGoods.imgList.length; j++) {
            if (this.formAddGoods.imgList[j] == file.url) {
              this.formAddGoods.imgList.splice(j, 1)
            }
          }
          this.hideNextUpload = false
        }
      }
    },
      uploadRemoveQualification(file) {
        for (let i = 0; i < this.qualificationFileList.length; i++) {
          if (this.qualificationFileList[i].url == file.url) {
            this.qualificationFileList.splice(i, 1)
            if (Array.isArray(this.formAddGoods.qualification)) {
              for (let j = 0; j < this.formAddGoods.qualification.length; j++) {
                if (this.formAddGoods.qualification[j] == file.url) {
                  this.formAddGoods.qualification.splice(j, 1)
                }
              }
            }
            this.hideQualificationUpload = false
          }
        }
      },
      handleRemove(file, type) {
        const url = file.url
        if (type === 'zt') {
          this.mainFileList = this.mainFileList.filter(item => item.url !== url)
          if (Array.isArray(this.formAddGoods.headImg)) {
            this.formAddGoods.headImg = this.formAddGoods.headImg.filter(u => u !== url)
          }
          this.hideMainUpload = this.mainFileList.length >= this.limitMainImg
        } else if (type === 'pt') {
          this.nextFileList = this.nextFileList.filter(item => item.url !== url)
          if (Array.isArray(this.formAddGoods.imgList)) {
            this.formAddGoods.imgList = this.formAddGoods.imgList.filter(u => u !== url)
          }
          this.hideNextUpload = this.nextFileList.length >= this.limitNextImg
        } else if (type === 'qualification') {
          this.qualificationFileList = this.qualificationFileList.filter(item => item.url !== url)
          if (Array.isArray(this.formAddGoods.qualification)) {
            this.formAddGoods.qualification = this.formAddGoods.qualification.filter(u => u !== url)
          }
          this.hideQualificationUpload = this.qualificationFileList.length >= this.limitQualificationImg
        }
      },
    /**
     * 提交
    */
    submitAddGoods(formAddGoods) {
      this.$refs[formAddGoods].validate((valid) => {
         console.log('33333',this.formAddGoods)
         console.log(this.unnits)
         const us=JSON.parse(JSON.stringify(this.unnits));

         const priceObj={
          
         }

         const newus=us?.map((item,i)=>{


            return{

              membershipPrice:Number(item.membershipPrice),
              price:Number(item.price),
              communityLeaderPrice:Number(item.communityLeaderPrice),
			  shipcost:Number(item.shipcost),
              vipPrice:Number(item.vipPrice),
              qcPrice:Number(item.qcPrice),
              name:item.unitNum+item.unit,
              stock:Number(item.stock)
            }
          

         })

         const skulist=newus.filter(item=> item.name)

          const obj = {
            ...this.formAddGoods,
            commission: this.commission,
            topPrice: this.formAddGoods.isExplosiveProducts ? parseFloat(this.formAddGoods.topPrice) : null,
            decsPrice: this.formAddGoods.isExplosiveProducts ?parseFloat( this.formAddGoods.decsPrice) : null,
            isExplosiveProducts: this.formAddGoods.isExplosiveProducts,
            isBanjiaProducts: this.formAddGoods.isBanjiaProducts,
            isVipFreeProducts: this.formAddGoods.isVipFreeProducts,
            noreason: this.formAddGoods.noreason,
            prem: this.formAddGoods.prem,
            instantrefund: this.formAddGoods.instantrefund,
            qualification: Array.isArray(this.formAddGoods.qualification) ? this.formAddGoods.qualification.join(',') : (this.formAddGoods.qualification || ''),
            goodType:1,
            reorder:this.formAddGoods.reorder,
            brand:this.formAddGoods.brand,
            salecomm:this.formAddGoods.salecomm

          }
          delete obj.skuList;
          if(newus.length>0 &&newus[0] && newus[0].name ){
            obj.skuList = skulist;
          }

          if(this.freightValue){
            obj.identity=this.freightValue;
          }
          if(this.freightValue=='z'){
           delete obj.freight;
          }

         console.log('12345',obj)

        // return
        if (valid) {
          // this.formAddGoods.headImg = this.formAddGoods.headImg[0].url.toString()  // 主图转字符串
          if (!this.formAddGoods.id) {
            // this.$message.success('添加成功！')
            console.log(this.formAddGoods)
            goods_GCAddGoods(obj).then(res => {
              this.$message.success('添加成功！')
              this.submitwScreen()
              this.visibleAddGoods = false
            })
          } else {
            // this.$message.success('修改成功！')
            console.log(obj)
            goods_GCEditGoods(obj).then(res => {
              console.log('1111111',res);
              
              this.$message.success('修改成功！')
              this.submitwScreen()
              this.visibleAddGoods = false
            })
          }
        } else {
          this.$message.error('请完善表单内容！')
          return false;
        }
      });
    },
    /**
     * 分页操作
    */
    resetPagination() {
      this.pagination.current = 1   // 重置分页参数
      // this.pagination.size = 20     // 重置分页参数
    },
    changePaginationCurrent(e) {
      this.pagination.current = e
      this.wScreen["pageModel.pageNo"] = this.pagination.current
      this.wScreen["pageModel.pageSize"] = this.pagination.size
      this.getGoodsData(this.wScreen)
    },
    changePaginationSize(e) {
      this.pagination.current = 1
      this.pagination.size = e

      this.wScreen["pageModel.pageNo"] = this.pagination.current
      this.wScreen["pageModel.pageSize"] = this.pagination.size
      this.getGoodsData(this.wScreen)
    },

    /**
     * 添加规格
    */
    addSpecification() {
      if (this.formAddGoods.skuList.length < 3) {
        this.formAddGoods.skuList.push({
          name: '', // 规格
          membershipPrice: 0, // 原价
          price: 0, // 现价
          vipPrice: 0, // VIP价
          stock: 0, // 库存
          key: Date.now()
        });
      } else {
        this.$message({
          message: '最多只能添加3个规格',
          type: 'warning'
        });
      }
    },
    removeSpecification(item) {
      let index = this.formAddGoods.skuList.indexOf(item)
      if (index !== -1) {
        this.formAddGoods.skuList.splice(index, 1)
      }
    },
    addUnit(){
      const obj= {
          membershipPrice:0,//会员价
          vipPrice:0,//VIP价
          qcPrice:0,//轻创价格价
          communityLeaderPrice:0,//社区团长价
		  shipcost:0,//运费
          price:0,//顾客价
          stock:"",//库存
          unitNum:"",//数量
          unit:"",//单位
        }
      const arr=JSON.parse(JSON.stringify(this.unnits))
      arr.push(obj)

      this.unnits=arr

      console.log('添加')
    },

    reduce(i){
     
      const arr=JSON.parse(JSON.stringify(this.unnits))
      const result = arr.reduce((acc, item, idx) => {
        if (idx !== i) { 
          acc.push(item);
        }
        return acc;
      }, []);

      this.unnits=result

      console.log('添加')
    }
  }
};
</script>

<style lang="less">
@import "@/assets/css/publicStyle.less";
.ql-editor {
  min-height: 100px;
}
.hide .el-upload--picture-card {
  display: none !important;
}
.goods-attr-line {
  display: flex;
  align-items: center;
  gap: 24px;
  margin: 12px 0;
}
.goods-attr-line .attr-label {
  margin-right: 6px;
}
/* 在style部分添加 */
.ql-editor video {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 10px 0;
  background-color: #f5f5f5;
}

/* 上传中的视频占位符样式 */
.ql-editor video[data-id] {
  width: 100%;
  height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px dashed #ddd;
}
.wML-screen {
  display: block;
  width: 100%;
  user-select: none;
  margin-bottom: 20px;

  // 筛选列表
  .wMLS-list {
    display: block;
    width: 100%;
  }
}

// 商品列表区域
.wGoodsList-area {
  display: block;
  width: 100%;
  padding: 20px 16px;
  box-sizing: border-box;
  background-color: #ffffff;

  // 商品类别
  .wGL-categoryArea {
    display: flex;
    justify-content: space-between;

    .wGL-category {
      flex: none;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      user-select: none;
      margin-bottom: 15px;

      .wGLC-item {
        flex: none;
        height: 40px;
        line-height: 40px;
        padding: 0 20px;
        margin-right: 10px;
        box-sizing: border-box;
        background-color: #f3f3f3;
        // border: 1px solid #999999;
        font-size: @wFontSize;
        cursor: pointer;
        transition: all 0.3s;

        &:hover,
        &.wActive {
          background-color: @wColor_theme;
          border-color: @wColor_theme;
          color: #ffffff;
        }
      }
    }
  }

  // 商品状态
  .wGL-state {
    display: flex;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    margin-bottom: 15px;

    .wGLS-category {
      flex: none;
      display: flex;
      align-items: center;

      .wGLSC-btn {
        flex: none;
        margin-right: 15px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: @wFontSize;
        color: #333333;

        &:hover,
        &.wActive {
          color: @wColor_theme;
          transition: all 0.3s;
        }
      }
    }

    .wGLS-operate {
      flex: none;
      display: flex;
      align-items: center;

      .wGLSO-btn {
        flex: none;
        margin-right: 7px;
        cursor: pointer;
        transition: all 0.3s;
        font-size: @wFontSize;
        color: #333333;

        &:hover {
          color: @wColor_theme;
          transition: all 0.3s;
        }
      }
    }
  }

  // 数据列表
  .wGL-goods {
    display: block;
    width: 100%;

    // table表
    .wGLG-table {
      display: block;
      width: 100%;
    }

    // 分页
    .wGLG-page {
      display: block;
      width: 100%;
      margin-top: 20px;
      text-align: center;
    }
  }
}

// 职务信息表单
.wDialogForm {
  display: block;
  width: 100%;
  height: 500px;
  position: relative;


  .wDialogForm-box {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }
}

.specification {
  .el-form-item__content {
    display: flex !important;
  }
}
.unitBox{
// display: flex;
border: 1px solid #eeeeee;
padding: 10px;
margin-bottom: 20px;
.unitTop{
  display: flex;
}
.unitBottom{
display: flex;
margin-top: 20px;
}
.pricebox{
  display: flex;
}
.input{
  margin-right: 5px;
  width: 150px;
}
.inputprice{
  width:86px;
}
  .goodsItem{
    display: flex;
    align-items: center;
    .span{
      text-wrap: nowrap;
      margin-right: 5px;
      margin-left: 5px;
      color: red;
      font-weight: bold;
    }
    .spankc{
      font-weight: normal;
      color: #606266;
      
    }
  
  
  }
  .but{
    margin-left: 10px;
    background: #FF6321;
    color: #ffffff;
  }
  .butdel{
    background: #ffffff;
    color: #333333;

  }
}

.addbutb{
  margin-left: 10px;
  background: #FF6321!important;
  color: #ffffff!important;
  margin-top:20px;
}
.el-dialog__body{
  overflow-y: auto!important;
  // height: 800px!important;
//height:600px !important;
}
.el-dialog{
  margin-top: 10vh !important;
}

.preview-img {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.preview-video {
  width: 100px;
  height: 100px;
  object-fit: cover;
}
.file-item {
  display: inline-block;
  margin: 5px;
}
.custom-upload-item{
  // display: flex!important;
  // align-items: center!important;
  // line-height: 148px!important;
  height: 100%!important;


}
</style>
